class CartItem extends HTMLElement {
  constructor() {
    super()

    this.parent = this.closest('main-cart')
    this.removeButtons = this.querySelectorAll('[data-remove]')
    this.quantityInput = this.querySelector('[data-quantity]')
    this.optionsSelects = this.querySelectorAll('[data-option]')
    this.variantsSelect = this.querySelector('[data-variants]')
    this.soldOut = this.querySelector('[data-unavailable-text]')

    this.debounceQuantityInput = debounce((event) => {
      this.updateItemQuantity(event)
    }, 500)

    this.removeButtons.forEach((button) => {
      button.addEventListener('click', this.updateItemQuantity.bind(this))
    })
    this.quantityInput.addEventListener(
      'change',
      this.debounceQuantityInput.bind(this)
    )
    this.optionsSelects.forEach((option) => {
      option.addEventListener('change', this.onOptionChange.bind(this))
    })
  }

  onOptionChange(event) {
    const optionSelector = Array.from(
      this.optionsSelects,
      (el) => `[data-option${el.dataset.optionPosition}="${el.value}"]`
    ).join('')
    const option = this.variantsSelect.querySelector(optionSelector)

    if (option.disabled) {
      this.toggleSoldOutError(option.disabled)

      return
    }

    const maxQuantity = Number(option.dataset.inventoryQuantity)
    const quantity =
      Number(this.quantityInput.value) > maxQuantity
        ? maxQuantity
        : Number(this.quantityInput.value)

    this.toggleSoldOutError(false)
    this.variantChange(option.value, quantity, maxQuantity)
  }

  updateItemQuantity(event) {
    event.preventDefault()

    const isRemove = event.target.dataset.remove !== undefined

    // Search if embroidery exist
    const currentItems = document.querySelectorAll('cart-item');
    var propertiesCurrentItem = this.querySelectorAll('.cart-item__meta-embroideryid');

    if (propertiesCurrentItem[0] != null){
      var cartItemEmbroidery = false;
      currentItems.forEach((cartItem) => {
        var propertiesCartItem = cartItem.querySelectorAll('.cart-item__meta-embroideryid');
        if (propertiesCartItem[0] != null && propertiesCurrentItem[0].innerHTML == propertiesCartItem[0].innerHTML && this.getAttribute('embroidery') == null && cartItem.getAttribute('embroidery')){
          // Remove embroidery product
          cartItemEmbroidery = cartItem.getAttribute('data-id');
          this.parent.updateItemsQuantity({
            [cartItemEmbroidery]: isRemove ? 0 : event.target.value,
            [this.dataset.id]: isRemove ? 0 : event.target.value
          })
          
          return false
        } else if (propertiesCartItem[0] != null && propertiesCurrentItem[0].innerHTML == propertiesCartItem[0].innerHTML && cartItem.getAttribute('embroidery') == null && this.getAttribute('embroidery')){
          cartItemEmbroidery = cartItem.getAttribute('data-id');

          // Option 1: Remove properties (embroidery Key)
          /*
          jQuery.post(window.Shopify.routes.root + 'cart/change.js', {
            updates: [{ 
              id: cartItemEmbroidery,
              properties: { '__EmbroideryID': false }
            },{
              id: this.dataset.id,
              quantity: 0
            }]
          })
          */

          // Option 2: Remove properties (embroidery Key)
          /*
          $.ajax({
            type: 'POST',
            url: '/cart/update.js',
            data: { 
              updates: [{ 
                id: cartItemEmbroidery,
                properties: { '__EmbroideryID': false }
              },{
                id: this.dataset.id,
                quantity: 0
              }]
            },
            dataType: 'json'
          })
          */

          // Remove only item (No removing ID)
          this.parent.updateItemQuantity({
            [this.dataset.id]: isRemove ? 0 : event.target.value
          })

        }
      })

      if (!cartItemEmbroidery){
        this.parent.updateItemQuantity({
          [this.dataset.id]: isRemove ? 0 : event.target.value,
        })
      }

    } else{
      this.parent.updateItemQuantity({
        [this.dataset.id]: isRemove ? 0 : event.target.value,
      })
    }

  }

  variantChange(id, quantity, maxQuantity) {
    this.parent.updateItemsQuantity(
      {
        [this.dataset.id]: 0,
        [id]: quantity,
      },
      maxQuantity
    )
  }

  toggleSoldOutError(hide) {
    this.soldOut.classList.toggle('hidden', !hide)
    this.soldOut.ariaHidden = !hide
  }
}

customElements.define('cart-item', CartItem)
